module.exports = __webpack_public_path__ + "static/img/mg.b23fb375.svg";